import React, { useEffect, useState } from 'react';

import { Button, Modal, TextField, WrapperFlex } from '@unimed-fesp/components';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Creators as WebhookEventHeaderIntegrationActions } from '../../../store/ducks/webhookEventHeaderIntegration';
import { ErrorToast } from '../../molecules/Toast';

function ModalCadastarWebhookEventHeader({
  isOpen,
  onClick,
  isEditar,
  webhookEventId,
  setIsEditarModal,
}) {
  const dispatch = useDispatch();

  const [inputNome, setInputNome] = useState('');
  const [inputValor, setInputValor] = useState('');

  const handleInputValor = (event) => {
    setInputValor(event.target.value);
  };
  const handleInputNome = (event) => {
    setInputNome(event.target.value);
  };

  const validarCamposHeaders = (nome, valor) => {
    const regexNome = /^[A-Za-z\-]+$/;
    const regexValor = /^[^\u00C0-\u017Fç]+$/;

    const nomeValido = regexNome.test(nome);
    const valorValido = regexValor.test(valor);
    return nomeValido && valorValido;
  };

  const limparInputs = () => {
    setInputValor('');
    setInputNome('');
  };

  const cadastrarHeader = () => {
    if (!inputValor || !inputNome)
      return toast.error(
        <ErrorToast size="30">Os campos são obrigatórios.</ErrorToast>
      );

    if (!validarCamposHeaders(inputNome, inputValor))
      return toast.error(
        <ErrorToast size="30">
          O cabeçalho HTTP fornecido é inválido. Certifique-se de que o nome e
          valor do cabeçalho está em conformidade com as especificações HTTP e
          que o valor é válido.
        </ErrorToast>
      );

    const params = {
      name: inputNome,
      webhookEventId,
      value: inputValor,
    };

    dispatch(
      WebhookEventHeaderIntegrationActions.postWebhookEventHeaderRequest(params)
    );
    limparInputs();
    onClick();
  };

  const editarHeader = () => {
    if (!inputValor || !inputNome)
      return toast.error(
        <ErrorToast size="30">Os campos são obrigatórios.</ErrorToast>
      );

    if (!validarCamposHeaders(inputNome, inputValor))
      return toast.error(
        <ErrorToast size="30">
          O cabeçalho HTTP fornecido é inválido. Certifique-se de que o nome e
          valor do cabeçalho está em conformidade com as especificações HTTP e
          que o valor é válido.
        </ErrorToast>
      );

    const params = {
      name: inputNome,
      webhookEventId,
      value: inputValor,
      entityId: isEditar.id,
    };

    dispatch(
      WebhookEventHeaderIntegrationActions.putWebhookEventHeaderRequest(params)
    );

    onClick();
    setIsEditarModal(false);
    limparInputs();
  };

  useEffect(() => {
    if (isEditar) {
      setInputValor(isEditar.value);
      setInputNome(isEditar.name);
    }
  }, [isEditar]);

  return (
    <Modal
      isOpen={isOpen}
      onClick={() => {
        onClick();
        limparInputs();
      }}
      height={345}
      width={600}
      header={isEditar ? 'Editar Header' : 'Cadastro de Header'}
      footer={
        <ModalFooter
          isEditar={isEditar}
          onClick={() => {
            onClick();
            limparInputs();
          }}
          cadastrarHeader={cadastrarHeader}
          editarHeader={editarHeader}
        />
      }
    >
      <WrapperFlex column fullWidth alignCenter justifyCenter>
        <TextField
          width={480}
          labelText="Nome"
          value={inputNome}
          onChange={(e) => {
            handleInputNome(e);
          }}
        />
        <TextField
          width={480}
          labelText="Valor"
          value={inputValor}
          onChange={(e) => {
            handleInputValor(e);
          }}
        />
      </WrapperFlex>
    </Modal>
  );
}

const ModalFooter = ({ isEditar, onClick, cadastrarHeader, editarHeader }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        marginRight={10}
        type={isEditar ? 'button' : 'submit'}
        width={120}
        alignCenter
        justifyCenter
      >
        Cancelar
      </Button>
      <Button
        tipo="primary"
        onClick={isEditar ? editarHeader : cadastrarHeader}
        marginLeft={10}
        type={isEditar ? 'button' : 'submit'}
        width={120}
        alignCenter
        justifyCenter
      >
        Salvar
      </Button>
    </>
  );
};

export default ModalCadastarWebhookEventHeader;
